<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 患者干预档案
-->

<template>
  <div class="page-content" ref="scrollContainer">
    <div class="page-header">
      <div class="header-title" @click="getContent">
        <span>AI推荐干预方案</span>
      </div>
      <div class="header-con" @click="toConnect">
        您好！结合您的身体状况制定了专属干预方案。在康复过程中，我们会持续关注您的恢复进展，适时为您优化调整方案细节：
      </div>
    </div>
    <div v-if="loadStatus == 0" class="loading-status">
      <img src="../assets/images/pending.gif" mode="scaleToFill" />
      AI连接中...
    </div>
    <div v-if="loadStatus == 1" class="loading-status">
      <img src="../assets/images/pending.gif" mode="scaleToFill" />
      思考中...
    </div>
    <div v-if="loadStatus == -1" class="loading-status">
      <img src="../assets/images/icon-fail.png" mode="scaleToFill" />
      生成失败
    </div>
    <div v-if="loadStatus == 2" class="loading-status">
      <img src="../assets/images/icon-fail.png" mode="scaleToFill" />
      已取消生成
    </div>
    <div v-if="loadStatus == 3" class="loading-status">
      <img src="../assets/images/icon-success.png" mode="scaleToFill" />
      回答完成
    </div>
    <!-- 方案列表 -->
    <div v-html="content" class="content">

    </div>
    <!-- <div class="h280" @click="goto"></div> -->
    <div class="btn-footer">
      <div class="btn" @click="closeCon">
        取消生成
      </div>
      <div class="btn" @click="goto">
        一键填充
      </div>
    </div>
  </div>
</template>

<script>
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import { contentAnalysis2 } from "../utils/utils";
export default {
  data() {
    return {
      loadStatus: 0,
      content: '',
      patientId:'',
      eventSource: null,
      messages: []
    };
  },
  mounted() {
    this.id =  getQueryString('id');
    this.patientId = getQueryString('patientId');
    this.phone =  getQueryString('phone');
    this.patientName = decodeURI(getQueryString('patientName', true));

    document.title = `干预方案`;

    this.toConnect()
    this.getSignature();

  },

  methods: {
    goto() {
      window.wx.ready(() => {
        window.wx.miniProgram.navigateTo({
          url: `/packageB/pages/intervenePlanTumor/planCard?patientId=${this.patientId}&phone=${this.phone}&patientName=${this.patientName}`,
        })
      })
    },
    getSignature() {
      ajax
        .Post({
          url: '/api/third/wx/getJsSdkAuthSignature',
          data: { appId: 'wx07f3a380dbc07549', type: 0, url: window.location.href }
        }).then(({ data: { data } }) => {
          window.wx.config({
            debug: false,
            appId: 'wx07f3a380dbc07549',
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['miniProgram']
          });
        })
    },
    toConnect() {

      if (this.eventSource) {
        this.eventSource.close();
      }
      // 创建 SSE 连接
      this.eventSource = new EventSource(`/api/ai/hlxj/sse/connected?clientId=${this.phone}`);

      // 监听服务器发送的消息
      this.eventSource.onmessage = this.handleEventMessage

      // 监听自定义事件
      this.eventSource.addEventListener('customEvent', (event) => {
        this.messages.push(`Custom Event: ${event.data}`);
      });

      // 处理错误
      this.eventSource.onerror = (error) => {
        console.error('SSE error:', error);
        this.eventSource.close();
      };
      setTimeout(() => {
        this.getContent()
      }, 200);
    },
    closeCon() {
      this.loadStatus = 2;
      this.eventSource.close();
    },
    getContent() {
      this.loadStatus = 1;
      ajax
        .Post({
          url: '/api/ai/hlxj/sse/chat/intervenePlan',
          data: {
            clientId: this.phone,
            baseDiseaseId: this.id
          }
        }).then(({ data: { success, data } }) => {
          if (success) {
            console.log("成功", data)
            this.loadStatus = 1
          } else {
            console.log("失败", data)
            this.loadStatus = -1
          }
        })
    },
    handleEventMessage(event) {
      console.log('Received data:', event.data);
      if (event.data === 'finishedEnd') {
        // setLoading(false)
        // setLoadingMsg("回答完成")
        this.loadStatus = 3
        if (this.eventSource) {
          this.eventSource.close();  // 关闭 EventSource 连接
        }
        // setEventSource(null);  // 清空保存的实例
        return
      }

      let modifiedData = event.data;

      this.content = contentAnalysis2(this.content + modifiedData);
      this.scrollToBottom();
    },
    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      container.scrollTop = container.scrollHeight;
    },
  },
  beforeDestroy() {
    // 组件销毁时关闭 SSE 连接
    if (this.eventSource) {
      this.eventSource.close();
    }
  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.page-content {
  height: 100vh;
  overflow: auto;
  background-color: #fff;
}

.page-header {
  width: 100%;
  height: auto;
  padding: 16px 24px;
  background: #FBB13D;
}

.page-header .header-title {
  width: 100%;
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.page-header .header-title span {
  font-size: 20px;
  font-weight: 500;
  color: #fff;
}

.page-header .header-con {
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
  text-align: justify;
  margin-bottom: 18px;
}

.loading-status {
  width: fit-content;
  height: 30px;
  display: flex;
  justify-content: start;
  gap: 10px;
  align-items: center;
  font-size: 14px;
  color: #666;
  font-weight: 500;
  right: 0;
  border-radius: 15px 0 0 15px;
  background: #FBB13D;
  position: fixed;
  top: 200px;
  padding: 0 10px;
  color: #fff;
}

.loading-status img {
  width: 20px;
  height: 20px;
  display: none;
}

.content {
  padding: 16px;
  font-size: 14px;
  margin-bottom: 100px;
}

/* 底部按钮 */
.btn-footer {
  position: fixed;
  bottom: 0;
  left: 0px;
  width: 100%;
  height: 83px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #FFFFFF;
  box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
  padding-bottom: 27px;
}

.btn {
  width: 45%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 1px;
  background: #FBB13D;
  border-radius: 24px;
}
</style>
